const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}`;

const TIMEOUT_MESSAGE =
  "Du lieu qua nang, vui long chon khoang thoi gian ngan hon";

const normalizeFilters = (filters = {}) => ({
  tuNgay: filters.tuNgay || "",
  denNgay: filters.denNgay || "",
  dsMaCH: Array.isArray(filters.dsMaCH) ? filters.dsMaCH : [],
});

const parseJsonSafely = async (response) => {
  try {
    return await response.json();
  } catch {
    return null;
  }
};

const isTimeoutMessage = (message = "") => {
  const normalized = String(message).toLowerCase();
  return (
    normalized.includes("timeout") ||
    normalized.includes("vuot qua 31 ngay") ||
    normalized.includes("quá nặng") ||
    normalized.includes("qua nang")
  );
};

const buildRequestError = (response, responseData) => {
  const status = response?.status;
  const backendMessage = responseData?.message || responseData?.error || "";
  const fallbackMessage = `Khong the tai du lieu (HTTP ${status || "unknown"})`;
  const message = backendMessage || fallbackMessage;
  const timeout = status === 408 || isTimeoutMessage(message);

  const error = new Error(timeout ? TIMEOUT_MESSAGE : message);
  error.status = status;
  error.isTimeout = timeout;
  error.backendMessage = message;
  return error;
};

const postThongKe = async (path, filters) => {
  const payload = normalizeFilters(filters);
  const response = await fetch(`${API_BASE_URL}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  const responseData = await parseJsonSafely(response);

  if (!response.ok) {
    throw buildRequestError(response, responseData);
  }

  return responseData;
};

const normalizeArrayField = (responseData, fieldName) => {
  if (Array.isArray(responseData?.[fieldName])) {
    return responseData[fieldName];
  }

  if (Array.isArray(responseData)) {
    return responseData;
  }

  return [];
};

export const fetchDoanhSo = async (filters) => {
  const responseData = await postThongKe("/api/thong-ke/doanh-so", filters);
  return normalizeArrayField(responseData, "THDoanhSo");
};

export const fetchDoanhSoSanPham = async (filters) => {
  const responseData = await postThongKe(
    "/api/thong-ke/doanh-so-san-pham",
    filters
  );
  return normalizeArrayField(responseData, "THDoanhSoSP");
};

export const fetchHoaDon = async (filters) => {
  const responseData = await postThongKe("/api/thong-ke/hoa-don", filters);
  return normalizeArrayField(responseData, "THHoaDon");
};

export const fetchChiTietBanHang = async (filters) => {
  const responseData = await postThongKe(
    "/api/thong-ke/chi-tiet-ban-hang",
    filters
  );
  return normalizeArrayField(responseData, "CTBanHang");
};

export const fetchThongKeAll = async (filters, options = {}) => {
  const { useSplitThongKeApi = true } = options;

  if (!useSplitThongKeApi) {
    const responseData = await postThongKe("/api/thong-ke", filters);
    return {
      THDoanhSo: normalizeArrayField(responseData, "THDoanhSo"),
      THDoanhSoSP: normalizeArrayField(responseData, "THDoanhSoSP"),
      THHoaDon: normalizeArrayField(responseData, "THHoaDon"),
      CTBanHang: normalizeArrayField(responseData, "CTBanHang"),
      errors: {},
    };
  }

  const settled = await Promise.allSettled([
    fetchDoanhSo(filters),
    fetchDoanhSoSanPham(filters),
    fetchHoaDon(filters),
    fetchChiTietBanHang(filters),
  ]);

  const [doanhSoResult, doanhSoSPResult, hoaDonResult, chiTietResult] = settled;

  return {
    THDoanhSo:
      doanhSoResult.status === "fulfilled" ? doanhSoResult.value : [],
    THDoanhSoSP:
      doanhSoSPResult.status === "fulfilled" ? doanhSoSPResult.value : [],
    THHoaDon: hoaDonResult.status === "fulfilled" ? hoaDonResult.value : [],
    CTBanHang: chiTietResult.status === "fulfilled" ? chiTietResult.value : [],
    errors: {
      doanhSo:
        doanhSoResult.status === "rejected" ? doanhSoResult.reason : null,
      doanhSoSP:
        doanhSoSPResult.status === "rejected" ? doanhSoSPResult.reason : null,
      hoaDon: hoaDonResult.status === "rejected" ? hoaDonResult.reason : null,
      chiTietBanHang:
        chiTietResult.status === "rejected" ? chiTietResult.reason : null,
    },
  };
};

export const thongKeErrorUtils = {
  TIMEOUT_MESSAGE,
  isTimeoutMessage,
};
